define('AAMS.OffersExtension.Offers.PopUp.Promo.View'
,   [
        'aams_offersextension_offers_popup_promo_panel.tpl'
    ],
    function (
        aams_offersextension_offers_popup_promo_panel_tpl
    ) {
        'use strict';
        return Backbone.View.extend({

            template: aams_offersextension_offers_popup_promo_panel_tpl,

            initialize: function (options) {
                
            },
            getContext: function getContext() {
                var self =this;
                var promoBannerContent = (SC.CONFIGURATION.PromoBannerContent && SC.CONFIGURATION.PromoBannerContent.config) || ""
                
                return {
                    promoBannerContent : promoBannerContent
                };
            }
        });
    });
